// extracted by mini-css-extract-plugin
export default {"layout":"SimplePatientPageLayout_layout__HczZC","firstColumn":"SimplePatientPageLayout_firstColumn__u0F0x","secondColumn":"SimplePatientPageLayout_secondColumn__byvQ4"};